<template>
  <BaseDataList ref="dataList" :items="products" :service="fetchProducts">
    <template #header>
      <ProductListHeader />
    </template>

    <template #default="{ item }">
      <ProductListItem
        :acc-product-id="accProductId"
        :product="item"
        @product-removed="refreshList"
      />
    </template>
  </BaseDataList>
</template>

<script>
import { accProductProductsClient } from '@/api/clients';
import mapKeysToCamelCase from '@/utils/map-keys-to-camel-case';
import ProductListHeader from './ProductListHeader.vue';
import ProductListItem from './ProductListItem.vue';

export default {
  components: {
    ProductListHeader,
    ProductListItem,
  },
  props: {
    accProductId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      products: [],
    };
  },
  methods: {
    refreshList() {
      this.$refs.dataList.resetList();
      this.$emit('change');
    },
    async fetchProducts() {
      try {
        const response = await accProductProductsClient.list(this.accProductId, {
          include: 'media',
        });

        this.products = response.data.map(mapKeysToCamelCase);

        return Promise.resolve(response);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  },
};
</script>
